import { APP_INITIALIZER, Provider } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { COOKIE_LANGUAGE_KEY, SessionStateService } from '@abp/ng.core';

/**
 * Removes the culture cookie that ABP core writes from script.
 *
 * `provideAbpCore` always registers ABP's `CookieLanguageProvider`, which writes
 * `.AspNetCore.Culture=c=<lang>|uic=<lang>` through `document.cookie` on every language change,
 * without a path or any security attribute. Such a cookie can never be HttpOnly or Secure (security
 * scan findings QID 150123 / 150122) and, lacking a path, it only ever applied to the directory of the
 * current URL. The culture cookie is issued by the API instead (see CultureQueryInterceptor), so this
 * initializer subscribes right after ABP's and deletes the stray cookie using the same default path
 * ABP wrote it with. It must be registered after `provideAbpCore` so that it runs second.
 */
export const LanguageCookieCleanupProvider: Provider = {
  provide: APP_INITIALIZER,
  multi: true,
  deps: [SessionStateService, DOCUMENT, COOKIE_LANGUAGE_KEY],
  useFactory: (sessionState: SessionStateService, document: Document, cookieLanguageKey: string) => () => {
    sessionState.getLanguage$().subscribe(() => {
      document.cookie = `${cookieLanguageKey}=; Max-Age=0`;
    });
  },
};
